import React from "react"

const UploadIcon = ({ size }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height="100" width="100" viewBox="0 0 512 512" style={{ width: size, height: size }} aria-hidden="true">
			<path fill="currentColor" d="M472 312.642v139c0 11.028-8.972 20-20 20H60c-11.028 0-20-8.972-20-20v-139H0v139c0 33.084 26.916 60 60 60h392c33.084 0 60-26.916 60-60v-139h-40z"/>
			<path fill="currentColor" d="M256 .358L131.716 124.642 160 152.926l76-76v311.716h40V76.926l76 76 28.284-28.284z"/>
		</svg>
	)
}

export default UploadIcon
